import { posApproval as PosApprovalAdapter } from '../infra/adaptors/pos_approval.adaptor';
import { createPosApprovalService } from '../application/services/pos_service';
import { baseBuild } from '@/core/services/network/config/baseBuild';
import type { AppDispatch } from '@/app/store/store';

export function posApprovalBuild(dispatch: AppDispatch) {
  return baseBuild(
    (d: AppDispatch) => new PosApprovalAdapter(d),
    (repo) => createPosApprovalService(repo),
    dispatch
  );
}